/* eslint-disable @typescript-eslint/no-explicit-any */
import type { App, DirectiveBinding } from 'vue'

const addToolTip = (el: any, binding: DirectiveBinding<any>) => {
  if (binding.value === undefined) {
    return
  }
  const tooltip = document.createElement('div')
  const elDimension = el.getBoundingClientRect()
  tooltip.setAttribute(
    'class',
    'bg-neutral-100/[0.9] max-w-[248px] text-shade-white text-xs rounded absolute w-fit py-1 px-3 top-0 left-0 m-2 z-[100]'
  )
  tooltip.setAttribute('id', 'tooltip')
  tooltip.innerHTML = binding.value
  document.body.appendChild(tooltip)

  const tooltipDimension = tooltip.getBoundingClientRect()

  if (elDimension.left + tooltipDimension.width / 2 > window.innerWidth) {
    tooltip.style.left = `${elDimension.right - tooltipDimension.width}px`
  } else if (elDimension.left - tooltipDimension.width / 2 < 0) {
    tooltip.style.left = `${elDimension.left}px`
  } else {
    const elMid = elDimension.x + elDimension.width / 2
    const tooltipMid = tooltipDimension.x + tooltipDimension.width / 2

    const diff = elMid - tooltipMid
    tooltip.style.left = `${diff}px`
  }

  if (elDimension.bottom + 1.5 * elDimension.height + tooltipDimension.height >= window.innerHeight) {
    tooltip.style.top = `${elDimension.bottom - 1.5 * elDimension.height - tooltipDimension.height}px`
  } else {
    tooltip.style.top = `${elDimension.bottom}px`
  }

}

const removeToolTip = () => {
  const elemToRemove = document.getElementById('tooltip')
  elemToRemove?.parentNode?.removeChild(elemToRemove)
}

const addedEvents: Array<{
  evt: 'mouseenter' | 'mouseleave'
  fnc: () => void
}> = []

const removeAddedEvents = (el: any) => {
  addedEvents.forEach((event) => {
    el.removeEventListener(event.evt, event.fnc)
  })

  addedEvents.slice(0, addedEvents.length)
}

const toolTipFunc = (el: any, binding: DirectiveBinding<any>) => {
  removeAddedEvents(el)

  el.className += ' cursor-default relative'

  const handleMouseEnter = function () {
    addToolTip(el, binding)
  }

  const handleMouseLeave = function () {
    removeToolTip()
  }

  addedEvents.push({ evt: 'mouseenter', fnc: handleMouseEnter })
  addedEvents.push({ evt: 'mouseleave', fnc: handleMouseLeave })

  el.addEventListener('mouseenter', handleMouseEnter)
  el.addEventListener('mouseleave', handleMouseLeave)
}

export default {
  install(app: App) {
    app.directive('tooltip', {
      updated: toolTipFunc,
      beforeMount: toolTipFunc,
    })
  },
}
